import { render } from "./RepLoadDialog.vue?vue&type=template&id=b8a54a80"
import script from "./RepLoadDialog.vue?vue&type=script&lang=js"
export * from "./RepLoadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__